import {createContext, useState} from "react";

export const IdpEventLogContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [idpEventLogs, setIdpEventLogs] = useState([]);

    // Make the context object:
    const idpEventLogContext = {
        idpEventLogs,
        setIdpEventLogs,
    };

    // pass the value in provider and return
    return <IdpEventLogContext.Provider value={idpEventLogContext}>{children}</IdpEventLogContext.Provider>;
}

export const {Consumer} = IdpEventLogContext;
